import React, { Component } from 'react';
import { Loader } from '../../../utils/common';
import { Row, Col, Modal, Button, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input, Form , Alert } from "reactstrap";
import { AppSwitch } from '@coreui/react'  
import SimpleReactValidator from 'simple-react-validator';


class UpdateSystemLanguage extends Component {
  constructor(props) {
    
    super(props);
    this.validator = new SimpleReactValidator();
    this.state = {
      languageId : props.selectedRow._id,
      title :  props.selectedRow.title,
      status :  props.selectedRow.status,
      allowForUsers : props.selectedRow.allowForUsers
    }
  }

  componentDidMount() {
  }

  componentWillReceiveProps(nextProps) {
   // let self = this;
    Loader(nextProps.requestProcess);
  }


  

  handleChange(event) {
    let target = event.target;
    let name = target.name;
    let value = target.value;
    if (name === 'status') {
      value = event.target.checked;
    }


    this.setState({[name]: value});
  }

  handleSubmit(e) {
    if( this.validator.allValid()){
      let params = {
        languageId : this.state.languageId,
        title : this.state.title,
        status : this.state.status,
        allowForUsers : this.state.allowForUsers,
      }  
      console.log(this.props)
      this.props.handleSubmit(e, params);
    }else{
      this.validator.showMessages();
      this.forceUpdate();
    }
    e.preventDefault();
  }

  



  render() {
    //let self = this;
    let { openUpdateLanguageModal, closeModal, popupError } = this.props;
    

    return (
      <Modal isOpen={openUpdateLanguageModal}>
          <ModalHeader toggle={()=>{closeModal(false)}}>Update System Language</ModalHeader>
          <Form onSubmit={(event) => {this.handleSubmit(event)}}>  
            <ModalBody>
              <Row>
                <Col xs="12">
                    <FormGroup>
                      <Label htmlFor="title">Language</Label>
                      <Input type="text" id="title" placeholder="Language Name" name="title" value={this.state.title} onChange={(event)=>{this.handleChange(event)}} />                                              
                      <div className="validation-error">{ this.validator.message('title', this.state.title, 'required') }</div>   
                    </FormGroup>
                </Col>
              </Row>


              <Row>
                  <Col xs="12">
                      <FormGroup>
                          <Label htmlFor="status">Status</Label>
                          <div>
                            <AppSwitch className={ 'mx-1'} variant={ 'pill'} color={ 'primary'}  id="status"  name="status"
                              onChange={($event)=>{this.handleChange($event)}}
                              checked={this.state.status}
                              value={this.state.status ? 'Active' : 'Inactive'} />
                          </div>
                      </FormGroup>
                  </Col>
              </Row>


              

              {(popupError) ? <Alert color="danger">{popupError}</Alert> : null}
            </ModalBody>
            <ModalFooter className="justify-content-left">
              <Button type="submit" size="sm" color="primary">Update</Button>{' '}
              <Button type="reset" size="sm" color="danger"  onClick={() => { closeModal() }}>Cancel</Button>
            </ModalFooter>
          </Form>
        </Modal>
      
    );
  }
}

export default UpdateSystemLanguage;
